import { render } from "./SalesView.vue?vue&type=template&id=c58d1a24&scoped=true"
import script from "./SalesView.vue?vue&type=script&lang=js"
export * from "./SalesView.vue?vue&type=script&lang=js"

import "./SalesView.vue?vue&type=style&index=0&id=c58d1a24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c58d1a24"]])

export default __exports__